<template>
    <div class="main-nav" :class="[bemFacets, rootFacets]">
        <navbar ref="mainNavBar" :items="items" :brand-logo-alt="brandLogoAlt"/>

        <scroll-reveal element-class="reduced-nav" class="main-nav--scroll-reveal">
            <navbar :facets="['reduced']" :items="items" :brand-logo-alt="brandLogoAlt"/>
        </scroll-reveal>
    </div>
</template>

<script>

    import bemMixin from 'framework/mixins/bem';
    import navContentVisibilityMixin from 'framework/mixins/navigation/content-visibility-observer';
    import { mapState } from 'vuex';
    import Navbar from 'framework/components/navigation/navbar/navbar';
    import ScrollReveal from 'framework/components/scroll-reveal/scroll-reveal';

    export default {
        components: { ScrollReveal, Navbar },
        mixins: [bemMixin('main-nav'), navContentVisibilityMixin],
        props: {
            /** @type {INavigationEntry[]} */
            items: {
                type: Array,
                required: true,
            },

            brandLogoAlt: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...mapState('navigation', ['mainVisible']),

            rootFacets() {
                return this.bemAdd(this.mainVisible ? 'hide-reduced' : null);
            },
        },

        beforeDestroy() {
            this.unregister(this.$refs.mainNavBar.$el);
        },

        mounted() {
            this.registerObserver(this.$refs.mainNavBar.$el, 0.9);
        },
    };
</script>
